module.exports = __webpack_public_path__ + "static/media/MHRP09N0012.af9482c1.svg";